import React, { PureComponent, Fragment } from 'react';
import { Card, CardBody, Col, Progress, Badge, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';

import UnitsSearchTableHead from './UnitsSearchTableHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import { Tooltip } from '@material-ui/core';
import moment from "moment";
import FloorPlanIcon from 'mdi-react/FloorPlanIcon';

import LinearLoading from '../../../shared/components/LinearLoading';
import StickyScrollbar from '../../../shared/components/StickyScrollbar';
import Button from '@material-ui/core/Button';
import LoadMoreIcon from 'mdi-react/RefreshIcon';
import LoadingIcon from 'mdi-react/DotsHorizontalIcon';

import CharityIcon from 'mdi-react/CharityIcon';

import OpenInNewIcon from 'mdi-react/OpenInNewIcon';

import AlertIcon from 'mdi-react/InformationOutlineIcon';
import UnitIcons from '../../../shared/components/UnitIcons';
import AddCollectionButton from '../../../shared/components/collections/AddCollectionButton';
import ArrowUpIcon from 'mdi-react/ChevronUpCircleOutlineIcon';
import ArrowDownIcon from 'mdi-react/ChevronDownCircleOutlineIcon';
import IconButton from '@material-ui/core/IconButton';
import ArrowEqualIcon from 'mdi-react/MinusCircleOutlineIcon';

import SkipTraceUnifiedModal from '../../../shared/components/skiptrace/SkipTraceUnifiedModal';
import SkipTracePDLProfileModal from '../../../shared/components/skiptrace/SkipTracePDLProfileModal';
import LisPendensModal from './LisPendensModal';


import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet
} from "react-device-detect";

import { 
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_nameToUrl,
	_shouldShow,
	_getBuildingURL,
	buildingFL,
	_replaceAbbreviations,
	_objectEqual,
	StatusBadge,
	_getUnitFloorPlan,
	UnitCurrentStatus,
	_formatUnitNumber,
	HouseCurrentStatus,
	_getFirstAndLastFromFullName,
	_extractIndividualNames,
	_isHouse,
	OwnershipTypeBadge,
	_ownersFrom,
	isCompanyName
} from "../../../shared/helpers/utils";

import { _axiosCall } from '../../../shared/helpers/apicalls';
const buildingUrl = process.env.API_ROOT + '/query/';

class UnitsListTable extends PureComponent{
	tableWrapRef = React.createRef();

	state = {
	    order: "",
	    orderBy: "",
	    selected: new Map([]),
	    page: 0,
	    rowsPerPage: 20,
	    fetchInProgress: false,
		buildingKey:false,
		unitListData:[],
		start:0,
		noMoreResults:false,
		selectedUnits: {},
		openModalKey: null,  // tracks which modal is currently open (e.g., 'property-id-owner-idx')
		lisPendensProperty: null  // tracks which property's lis pendens modal is open
	};

	componentDidMount() {
		
		if(this.props.buildingKey){
			this.queryUnits();
		}
	  	
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		
		if(this.props.buildingKey){
		  if(!_objectEqual(this.props.q, prevProps.q) ||
		  (this.props.buildingKey !== prevProps.buildingKey ||
		   this.state.orderBy !== prevState.orderBy ||
		   this.state.order !== prevState.order ||
		   this.state.start !== prevState.start)){
			   
			 const reset = this.state.orderBy !== prevState.orderBy || this.state.order !== prevState.order;
			 this.queryUnits(reset);
		  }		 
		}
		 
    }
    
    _loadMore = () => {
	  if(this.state.fetchInProgress === true){
		  	return false;
	  }
	  this.setState({ start: (this.state.start+this.state.rowsPerPage) });    
	  
    }
    
    _handleRequestUnitsSort = (event, property) => {
	    const orderBy = property;
	    let order = 'desc';
	    
	console.log(event, property);    
	    const { orderBy: stateOrderBy, order: stateOrder } = this.state;
	
	    if (stateOrderBy === property && stateOrder === 'desc') { order = 'asc'; }
	
	    this.setState({ order, orderBy, start: 0 });
	};
	

	
	queryUnits = async(reset) => {
		
		if (!this.state.fetchInProgress) {
			this.setState(prevState => ({ fetchInProgress: true, }));
		}
		
		const {buildingKey, q, fq, fl } = this.props;	
		const { orderBy, order } = this.state;
		
		const isContract = this.props.subFilters.offering_status && this.props.subFilters.offering_status === 'in-contract';
		
		let sort = "floor asc, address_2_normalized asc"
		if(this.state.orderBy && this.state.orderBy.length > 0){
			
			if(orderBy === 'address_2_normalized'){
				sort = `floor ${order}, ${orderBy} ${order}`;
			}else if(orderBy === 'offering_price'){
				sort = `last_listed_sale_price_all ${order}, ${orderBy} ${order}`;
			}else if(orderBy === 'last_sold_date'){
				if(isContract){
					sort = `last_contract_date ${order}`;
				}else{
					sort = `${orderBy} ${order}, last_contract_date ${order}`;
				}
			}else{
				sort = `${orderBy} ${order}`;
			}
			
		}
		
		const unitsFq = [...fq, `building:${buildingKey}`];			
		let axiosData = {
			url: buildingUrl + "we3-properties?cache=60",
			method: "post",
			query: {
				q: q,
				fq: unitsFq,
				sort: sort,
				fl,
				wt: "json",
				rows: this.state.rowsPerPage,
				start: this.state.start,
						
			}
		};

		let response = await _axiosCall(axiosData)
			.then(res => {
				if(res && res.docs && res.docs.length>0){
					const newUnitListData = reset ? res.docs : [...this.state.unitListData, ...res.docs];
					this.setState( { unitListData: newUnitListData, fetchInProgress: false, buildingKey:false })
				}else if(res.docs.length === 0 ){
					this.setState( { noMoreResults: true, fetchInProgress: false, buildingKey:false })
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});
	}
	
	_selectUnit(property){
		const { selectedUnits } = this.state;
		const { handleSelectParent } = this.props;
		const newSelected = Object.assign({}, selectedUnits);
		
		if(newSelected[property.key]){
			delete newSelected[property.key];			
		}else{
			newSelected[property.key] = property;
		}
		handleSelectParent(property);
		
		this.setState( { selectedUnits: Object.assign({}, newSelected) } );
	}
	
	_handleSelectAllClick(){
		const { unitListData } = this.state;
		const { handleSelectParentAll, selectedUnitsAll } = this.props;
		const { reactTableFiltered, groupedView, buildingKey } = this.props;
		const data = (groupedView || buildingKey) ? unitListData : reactTableFiltered;
		if(!data) return;
		const currentPageSelectedCount = data.filter(item => selectedUnitsAll[item.key] !== undefined).length;
		if(currentPageSelectedCount < data.length){
			handleSelectParentAll(data, "add");
		}else{
			handleSelectParentAll(data, "remove");
		}
	}

	handleOpenModal = (modalKey) => {
		this.setState({ openModalKey: modalKey });
		if (this.props.onSkipTraceModalOpen) {
			this.props.onSkipTraceModalOpen();
		}
	};

	handleCloseModal = () => {
		this.setState({ openModalKey: null });
		if (this.props.onSkipTraceModalClose) {
			this.props.onSkipTraceModalClose();
		}
	};

	handleOpenLisPendens = (d) => {
		this.setState({ lisPendensProperty: d });
	};

	handleCloseLisPendens = () => {
		this.setState({ lisPendensProperty: null });
	};

	// 2) NEW: extract individual names from an owner string




	_renderCellValue(columnId, d, { user, building, isGrouped, buildingData, owners, opPriceChange, soldPriceChange, isHouse }) {
		switch(columnId) {
			case 'owner':
				return (
					<div style={{display:'inline-flex',alignItems:'flex-start',gap:6}}>
						<div>
							{owners.map((name, idx) => {
							  var person = _getFirstAndLastFromFullName(name);
							  var displayName = person.display ? person.display : [person.first_name, person.middle_name, person.last_name]
							  .filter(Boolean)
							  .join(' ');
							  var modalKey = d.id + '-' + idx;
							  return (
								<SkipTraceUnifiedModal
								  user={user}
								  key={'stm-' + idx}
								  first_name={'' + person.first_name}
								  last_name={'' + person.last_name}
								  address_1={'' + d.display_full_street_address}
								  address_2={'' + d.address_2_normalized}
								  city={'' + d.city}
								  county={'' + d.county}
								  state={'' + d.state}
								  zip={'' + d.zip}
								  triggerDisplay={_capitalizeText(displayName)}
								  borough_code={d.borough_code}
								  block={d.block}
								  lot={d.lot}
								  property={d}
								  isOpen={this.state.openModalKey === modalKey}
								  onOpen={() => this.handleOpenModal(modalKey)}
								  onClose={this.handleCloseModal}
								/>
							  )
							})}
						</div>
						{d.absentee_owner && String(d.property_status || '').toLowerCase() !== 'sponsor' && (
							<span style={{flexShrink:0,marginTop:3,padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(255,200,0,0.18)',color:'#7a5c00',border:'1px solid rgba(255,200,0,0.45)',fontWeight:500,whiteSpace:'nowrap'}}>Absentee</span>
						)}
						{/* Unmasked pill removed — SkipTraceUnifiedModal trigger now shows the signatory name with the LLC in parens */}
						{/* {d.llc_unmasked && (
							<span title={d.llc_signatory_name} style={{padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(0,170,255,0.13)',color:'#0059a3',border:'1px solid rgba(0,170,255,0.35)',fontWeight:500,whiteSpace:'nowrap'}}>Unmasked</span>
						)} */}
					</div>
				);
			case 'bedrooms':
				return <span className="light-text small-text">{d.bedrooms > -1 ? d.bedrooms === 0 ? 'Studio' : d.bedrooms+' Bed' : '--'}</span>;
			case 'baths':
				return <span className="light-text small-text">{d.baths > -1 ? d.baths+' Bath' : '--'}</span>;
			case 'last_listed_sale_date_all':
				return d.last_listed_sale_date_all && d.last_listed_sale_date_all > 0 && parseInt(moment.unix(d.last_listed_sale_date_all).format('YYYY')) > 1970 ?
					<Fragment>
					<span className="light-text small-text">{moment.unix(d.last_listed_sale_date_all).format('MM/DD/YYYY')}</span>
					<span className="light-text xsmall-text no-wrap"><br/>({moment.unix(d.last_listed_sale_date_all).fromNow()})</span>
					</Fragment>
					:
					<span className="light-text small-text">--</span>;
			case 'last_sold_date':
				return d.current_status === 'in contract' ?
					<Fragment>
					{parseInt(moment.unix(d.last_contract_date).format('YYYY')) > 1970 ?
						<Fragment>
						<span className="light-text small-text">{moment.unix(d.last_contract_date).format('MM/DD/YYYY')}</span>
						<span className="light-text xsmall-text no-wrap"><br/>(Contract Date - {moment.unix(d.last_contract_date).fromNow()})</span>
						</Fragment>
					:
						<span className="light-text xsmall-text no-wrap">--</span>
					}
					</Fragment>
					: d.current_status === 'not_yet_recorded' ?
						<span className="light-text small-text no-wrap">Not Yet Recorded</span>
					  : d.last_sold_date && d.last_sold_date !== 0 ?
					  <Fragment>
					<span className="light-text small-text">{moment.unix(d.last_sold_date).format('MM/DD/YYYY')}</span>
					<span className="light-text xsmall-text no-wrap"><br/>({moment.unix(d.last_sold_date).fromNow()})</span>
					{d.current_status === 'not_yet_recorded' && <span className="light-text xsmall-text no-wrap"><br/>(Not Yet Recorded)</span>}
					</Fragment>
					:
					  <span className="light-text small-text">--</span>;
			case 'last_sold_price':
				return (d.last_sold_price && d.last_sold_price > 100) ?
					<Fragment>
						<span className="small-text">{_shouldShow(d.last_sold_price) ? `$${_formatNumber(d.last_sold_price)}` : "--"}
					  {soldPriceChange === false ? null : soldPriceChange > 0 ?
							<Tooltip title={`Unit was last listed for ${soldPriceChange}% above the last asking price`}>
								<IconButton size={`small`} style={{background:'transparent'}}>
								<ArrowUpIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#4ce1b6" />
							  </IconButton>
							</Tooltip> :
						soldPriceChange == 0 ?
							<Tooltip title={`Unit was last listed for the same price as the last asking price`}>
								  <IconButton size={`small`} style={{background:'transparent'}}>
								  <ArrowEqualIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#A3ADC2" />
								</IconButton>
							  </Tooltip>
							  :
							<Tooltip title={`Unit was last listed for ${soldPriceChange}% below the last asking price`}>
								<IconButton size={`small`} style={{background:'transparent'}}>
								<ArrowDownIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#FF206E" />
							  </IconButton>
							</Tooltip>
					  }
					  </span>
					  {soldPriceChange !== false ?
						<span className="light-text small-text" style={{color:"#858AA1"}}>
							  <br/> {soldPriceChange > 0 ? "+": ""}{soldPriceChange ==0 ? '-0%' : `${soldPriceChange}%`} vs. OP
						  </span>
						  :null
					  }
					</Fragment>
				:
					<Fragment>
						<span className="light-text small-text">--</span>
					</Fragment>;
			case 'div(last_sold_price,sq_ft)':
				return typeof d["div(last_sold_price, sq_ft)"] === 'number' && d["div(last_sold_price, sq_ft)"] > 100 ?
					<span className="small-text">${_formatNumber(d["div(last_sold_price, sq_ft)"])}</span>
					:
					<span className="small-text">--</span>;
			case 'last_listed_sale_price_all':
				return (d.offering_status === 'in contract') && _shouldShow(d.last_contract_price) && d.last_contract_price > 100  ?
					<Fragment>
						<span className="small-text">
							{_shouldShow(d.last_contract_price) ? `$${_formatNumber(d.last_contract_price)}` : "--"}
						</span>
					</Fragment>
				: _shouldShow(d.last_listed_sale_price_all) && d.last_listed_sale_price_all > 100 ?
					<Fragment>
						<span className="small-text">
							{_shouldShow(d.last_listed_sale_price_all) ? `$${_formatNumber(d.last_listed_sale_price_all)}` : "--"} {opPriceChange === false ? null : opPriceChange > 0 ?
								  <Tooltip title={`Unit was last listed for ${opPriceChange}% above the initial offering price`}>
								  	<IconButton size={`small`} style={{background:'transparent'}}>
									  <ArrowUpIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#4ce1b6" />
									</IconButton>
								  </Tooltip> :
							  opPriceChange == 0 ?
							  	<Tooltip title={`Unit was last listed for the same price as the initial offering price`}>
										<IconButton size={`small`} style={{background:'transparent'}}>
										<ArrowEqualIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#A3ADC2" />
									  </IconButton>
									</Tooltip>
									:
								  <Tooltip title={`Unit was last listed for ${opPriceChange}% below the initial offering price`}>
								  	<IconButton size={`small`} style={{background:'transparent'}}>
								  	<ArrowDownIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#FF206E" />
									</IconButton>
								  </Tooltip>
							}
						</span>
						{opPriceChange !== false ?
						  <span className="light-text small-text" style={{color:"#858AA1"}}>
								<br/> {opPriceChange > 0 ? "+": ""}{opPriceChange ==0 ? '-0%' : `${opPriceChange}%`} vs. OP
							</span>
							:null
						}
					</Fragment>
				:
					<Fragment>
						<span className="small-text">{_shouldShow(d.offering_price) ? `$${_formatNumber(d.offering_price)}` : "--"}</span>
						{_shouldShow(d.offering_price) && <span className="light-text xsmall-text no-wrap"></span>}
					</Fragment>;
			case 'div(last_listed_sale_price_all,sq_ft)':
				return typeof d["div(last_listed_sale_price_all, sq_ft)"] === 'number' && d["div(last_listed_sale_price_all, sq_ft)"] > 100 ?
					<span className="small-text">${_formatNumber(d["div(last_listed_sale_price_all, sq_ft)"])}</span>
					:
					<span className="small-text">--</span>;
			case 'offering_sq_ft':
				return d.offering_verified_status === "active" || d.offering_sq_ft > -1 ?
					<span className="light-text small-text">{_shouldShow(d.offering_sq_ft) ? _formatNumber(d.offering_sq_ft)+' sf' : '--'}</span>
				:
					<span className="light-text small-text">{_shouldShow(d.sq_ft) ? _formatNumber(d.sq_ft)+' sf' : '--'}</span>;
			case 'offering_exterior_sq_ft':
				return <span className="light-text small-text">{_shouldShow(d.offering_exterior_sq_ft) ? <React.Fragment>{_formatNumber(d.offering_exterior_sq_ft)} sf</React.Fragment>  : `--`}</span>;
			default:
				return '--';
		}
	}

	render(){
		const { reactTableFiltered, handleBuildingClick, isSelected, handleClick, order, orderBy, selected, emptyRows, handleSelectAllClick, handleRequestSort, isGrouped, user, building, selectedUnitsAll, visibleColumns, allColumns: allColumnsProp} = this.props;
		
		if(!reactTableFiltered && (this.state.start===0 && (this.state.unitListData.length===0 || this.props.fetchInProgress))){
			return (
				<LinearLoading />
			)
		}

		const data = reactTableFiltered || this.state.unitListData;
		const currentPageSelectedCount = data ? data.filter(d => selectedUnitsAll[d.key] !== undefined).length : 0;
		
		
		if(building && (building.offering_verified_status != 'active' &&  parseInt(moment(building.cdec_date).format('YYYY')) <= 1970) && data.length <= 0 ){
			
			return (
			  <Col md={12}>
			    <Card>
			      <CardBody className={`small`}>
			        <div className={`email-confirmation`} >
			          <div className="email-confirmation__icon">
			            <AlertIcon size={50} color={`#D6BAE8`} />			            
			          </div>
			          <h3 className="email-confirmation__title">Unit Info Not Available</h3>
			          <p className="email-confirmation__sub">Marketproof is currently acquiring and verifying information for the building.
More details will be added to this building as they become available.</p>
			          
			        </div>
			      </CardBody>
			    </Card>
			  </Col>
			  )

		}else if( data.length <= 0 ){
			return (
			  <Col md={12}>
			    <Card>
			      <CardBody className={`small`}>
			        <div className={`email-confirmation`} >
			          <div className="email-confirmation__icon">
			            <AlertIcon size={50} color={`#D6BAE8`} />
			          </div>
			          <h3 className="email-confirmation__title">No Units Found</h3>
			          <p className="email-confirmation__sub"></p>

			        </div>
			      </CardBody>
			    </Card>
			  </Col>
			  )
		}

		// Dynamic column mode with sticky first column
		if (visibleColumns && allColumnsProp) {
			const dynamicCols = allColumnsProp.filter(col => visibleColumns.includes(col.id) && col.id !== 'address_2_normalized');
			return (
			<Fragment>
				<div className="property-search-table">
				<div className="material-table__wrap" ref={this.tableWrapRef} style={{ overflowX: 'auto' }}>
				<Table className="material-table">
					<UnitsSearchTableHead
					  numSelected={currentPageSelectedCount}
					  order={order}
					  orderBy={orderBy}
					  onSelectAllClick={this._handleSelectAllClick.bind(this)}
					  onRequestSort={isGrouped ? this._handleRequestUnitsSort : handleRequestSort}
					  rowCount={data.length}
					  visibleColumns={visibleColumns}
					  allColumns={allColumnsProp}
					  useFrozenHeader
					/>
					<TableBody>
					  {data.map((d) => {
						const buildingData = d;
						var owners = _extractIndividualNames(d.owner);
						var isHouse = _isHouse(d);
						if (owners.length === 0 && d && d.owner) {
							owners = [String(d.owner)];
						}
						if(building && building.offering_verified_status === 'sold out'){
							if(["active", "not_yet_recorded", "sold", "in contract", "resale"].indexOf(d.offering_status) < 0){
								d.offering_status = "sold";
							}
						}
						if(d.baths % 1 == 0 && d.half_baths>0){
							d.baths = d.baths + .5;
						}
						let opPriceChange = false;
						let soldPriceChange = false;
						if(building && building.building_status === 'sponsor'){
							if((["active", "in contract", "pending"].indexOf(d.current_status)>=0) && typeof d["div(sub(offering_price, last_listed_sale_price_all), offering_price)"] === 'number' && d["offering_price"]>1000 ){
								opPriceChange = Math.round(d["div(sub(offering_price, last_listed_sale_price_all), offering_price)"] * 10000 * -1)/100;
							}
							if(d.last_sold_price > 1000 && typeof d["div(sub(offering_price, last_sold_price), offering_price)"] === 'number' && d["offering_price"]>1000 ){
								soldPriceChange = Math.round(d["div(sub(offering_price, last_sold_price), offering_price)"] * 10000 * -1)/100;
							}
						}
						const cellCtx = { user, building, isGrouped, buildingData, owners, opPriceChange, soldPriceChange, isHouse };
						return (
							<TableRow
								className="material-table__row"
								role="checkbox"
								onClick={event => handleBuildingClick(event, d)}
								tabIndex={-1}
								key={d.id}
								selected={selectedUnitsAll[d.key] !== undefined}
							>
								<TableCell className="material-table__cell ps-table__cell--frozen" padding="none">
									<div className="ps-table__frozen-content">
										<Checkbox checked={selectedUnitsAll[d.key] !== undefined} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this._selectUnit(d); }} className={`material-table__checkbox ${selectedUnitsAll[d.key] !== undefined && 'material-table__checkbox--checked'}`} style={{ padding: 4 }} />
										<div className="ps-table__checkbox" style={{ marginRight: 8, width: 120, minWidth: 120 }}>
											<HouseCurrentStatus status={d.current_status} unit={d} />
										</div>
										<div className="ps-table__address">
											{isGrouped || this.props.buildingView ?
												<div className="icon__floorplan"><span>{_formatUnitNumber(d.address_2_normalized, building).replace("#", "Apt")}</span>
													<UnitIcons building={building} unit={d} />
													<Fragment>
														<OpenInNewIcon size={14} style={{ marginTop:"-3px", marginLeft:"5px"}} color={'#BFC4D1'} onClick={(e) => {e.preventDefault();e.stopPropagation();window.open(`${_getBuildingURL(buildingData, 'building_slugs')}/${_nameToUrl(d.address_2_normalized)}`); }} />
													</Fragment>
													{d.foreclosure_case && (
														<Tooltip title="Click for Lis Pendens details" arrow>
															<span
																onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleOpenLisPendens(d); }}
																style={{marginLeft:6,padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(220,53,69,0.13)',color:'#a01228',border:'1px solid rgba(220,53,69,0.45)',fontWeight:500,whiteSpace:'nowrap',cursor:'pointer',display:'inline-block'}}
															>Lis Pendens</span>
														</Tooltip>
													)}
												</div>
											:
												<div className="icon__floorplan">
													<span>{d.name ? _capitalizeText(d.name) : _capitalizeText(_replaceAbbreviations(d.display_full_street_address))}{isHouse ? "" : ", " + d.address_2_normalized.toUpperCase().replace("APT", "Apt")}</span>
													<OwnershipTypeBadge ownership_type={d.ownership_type} />
													{!isMobile && <Fragment>
														<OpenInNewIcon size={14} style={{ marginTop:"-3px", marginLeft:"5px"}} color={'#BFC4D1'} onClick={(e) => {e.preventDefault();e.stopPropagation();window.open(`${isHouse ? _getBuildingURL(buildingData, 'building_slugs') : _getBuildingURL(buildingData, 'building_slugs')}/${_nameToUrl(d.address_2_normalized)}`); }} />
													</Fragment>}
													{d.foreclosure_case && (
														<Tooltip title="Click for Lis Pendens details" arrow>
															<span
																onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleOpenLisPendens(d); }}
																style={{marginLeft:6,padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(220,53,69,0.13)',color:'#a01228',border:'1px solid rgba(220,53,69,0.45)',fontWeight:500,whiteSpace:'nowrap',cursor:'pointer',display:'inline-block'}}
															>Lis Pendens</span>
														</Tooltip>
													)}
													<br/><span className="light-text small-text" style={{color:"#858AA1"}}>{d.neighborhood && d.neighborhood[0] ? `${_capitalizeText(d.neighborhood[0])}, ` : ''} {_capitalizeText(d.borough)}</span>
												</div>
											}
										</div>
									</div>
								</TableCell>
								{dynamicCols.map(col => (
									<TableCell
										className="material-table__cell material-table__cell-right ps-table__cell--scroll"
										key={col.id}
										size="small"
										style={col.id === 'owner' ? {minWidth:250,maxWidth:400,whiteSpace:"normal"} : undefined}
									>
										{this._renderCellValue(col.id, d, cellCtx)}
									</TableCell>
								))}
							</TableRow>
						);
					  })}
					</TableBody>
				</Table>
				</div>
				<StickyScrollbar scrollContainerRef={this.tableWrapRef} />
				</div>
				{!reactTableFiltered &&
				<div className="unit__load">
					<Tooltip title="Load more units">
						<Button
							onClick={(e) => {this._loadMore(e)}}
							 variant="contained"
							 color="news"
							 className={`timeline__load-more`}
							 startIcon={<LoadMoreIcon />}
							 disabled={this.state.fetchInProgress || this.state.noMoreResults}
						 >	{`${this.state.fetchInProgress ? "Loading..." : this.state.noMoreResults ? "No More Units" : "Load More"}`}
						 </Button>
					</Tooltip>
				</div>
				}
				<LisPendensModal
					isOpen={!!this.state.lisPendensProperty}
					onClose={this.handleCloseLisPendens}
					foreclosureCase={this.state.lisPendensProperty && this.state.lisPendensProperty.foreclosure_case}
					property={this.state.lisPendensProperty}
				/>
			</Fragment>
			);
		}


		return (
		<Fragment>
			<div>

			<Table className="material-table">
		        <UnitsSearchTableHead
		          numSelected={currentPageSelectedCount}
		          order={order}
		          orderBy={orderBy}
		          onSelectAllClick={this._handleSelectAllClick.bind(this)}
		          onRequestSort={isGrouped ? this._handleRequestUnitsSort : handleRequestSort}
		          rowCount={data.length}
		        />
		        <TableBody>
		          {data
		            .map((d) => {
		              const itemSelected = isSelected(d.id);
		              const floorplan = false; //_getUnitFloorPlan(d);
					  const buildingData = d;
					  var owners = _extractIndividualNames(d.owner);
					  var self = this;
					  var isHouse = _isHouse(d)

					  // Fallback: if no individuals detected, still try with the raw owner
					  if (owners.length === 0 && d && d.owner) {
						owners = [String(d.owner)];
					  }
					  //If building is sold out override stats
					  if(building && building.offering_verified_status === 'sold out'){						  
						  if(["active", "not_yet_recorded", "sold", "in contract", "resale"].indexOf(d.offering_status) < 0){
							  d.offering_status = "sold";
						  }						  
					  }
					  
					  if(d.baths % 1 == 0 && d.half_baths>0){
						  d.baths = d.baths + .5;
						  					  
					  }
					  let opPriceChange = false;
					  let soldPriceChange = false;
					  
					  if(building && building.building_status === 'sponsor'){	
					  	if((["active", "in contract", "pending"].indexOf(d.current_status)>=0) && typeof d["div(sub(offering_price, last_listed_sale_price_all), offering_price)"] === 'number' && d["offering_price"]>1000 ){
						 	opPriceChange = Math.round(d["div(sub(offering_price, last_listed_sale_price_all), offering_price)"] * 10000 * -1)/100;
					  	}
					  	if(d.last_sold_price > 1000 && typeof d["div(sub(offering_price, last_sold_price), offering_price)"] === 'number' && d["offering_price"]>1000 ){
						   	soldPriceChange = Math.round(d["div(sub(offering_price, last_sold_price), offering_price)"] * 10000 * -1)/100;
						}
					  }
		              return (
		                <TableRow
		                  className="material-table__row"
		                  role="checkbox"
		                  onClick={event => handleBuildingClick(event, d)}
		                  aria-checked={itemSelected}
		                  tabIndex={-1}
		                  key={d.id}
		                  selected={selectedUnitsAll[d.key] !== undefined}
		                >

		                  <TableCell className="material-table__cell" padding="checkbox">
								 <Checkbox checked={selectedUnitsAll[d.key]===undefined ? false : true} onClick={(e)=>{e.preventDefault();e.stopPropagation(); this._selectUnit(d);}} className={`material-table__checkbox ${selectedUnitsAll[d.key]!==undefined && 'material-table__checkbox--checked'}`} />
						  </TableCell>
		                 {!isMobile && <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small"                          
		                  >
		                  	 <HouseCurrentStatus status={d.current_status} unit={d} />
		                  	 {/*d.current_status === 'not_yet_recorded' && 
			                  	 <div className="light-text xsmall-text no-wrap text-center" style={{marginTop:3}}>(Not Yet Recorded)
			                  	 </div>*/}
								   {/* 
							 <SkipTraceModal
							   first_name={`${this._getFirstAndLastFromFullName(d.owner).first_name}`}
							   last_name={`${this._getFirstAndLastFromFullName(d.owner).last_name}`}
							   address_1={`${d.display_full_street_address}`}
							   address_2={`${d.address_2_normalized}`}
							   city={`${d.city}`}
							   county={`${d.county}`}
							   state={`${d.city}`}
							   zip={`${d.zip}`}
							   triggerDisplay={name}
							 /> */}
		                  </TableCell> }
		                
		                  <TableCell
		                    className="material-table__cell material-table__cell-right nowrap"
		                    component="td"
		                    scope="row"
		                    padding=""
		                  >
		                  	 {isGrouped || this.props.buildingView ?
		                      <div className="icon__floorplan"><span>{_formatUnitNumber(d.address_2_normalized, building).replace("#", "Apt")}</span>

			                    <UnitIcons building={building} unit={d} />
			                   	<Fragment>
						  			<OpenInNewIcon size={14} style={{ marginTop:"-3px", marginLeft:"5px"}} color={'#BFC4D1'} onClick={(e) => {e.preventDefault();e.stopPropagation();window.open(`${_getBuildingURL(buildingData, 'building_slugs')}/${_nameToUrl(d.address_2_normalized)}`); }} />
						  		</Fragment>
				                   	{d.foreclosure_case && (
				                   		<Tooltip title="Click for Lis Pendens details" arrow>
				                   			<span
				                   				onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleOpenLisPendens(d); }}
				                   				style={{marginLeft:6,padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(220,53,69,0.13)',color:'#a01228',border:'1px solid rgba(220,53,69,0.45)',fontWeight:500,whiteSpace:'nowrap',cursor:'pointer',display:'inline-block'}}
				                   			>Lis Pendens</span>
				                   		</Tooltip>
				                   	)}

		                      </div>
			                 :
			                  <div className="icon__floorplan">
			                  	<span>{d.name ? _capitalizeText(d.name) : _capitalizeText(_replaceAbbreviations(d.display_full_street_address))}{isHouse ? "" : ", " + d.address_2_normalized.toUpperCase().replace("APT", "Apt")}</span>

			                    <OwnershipTypeBadge ownership_type={d.ownership_type} />
			                    {!isMobile && <Fragment>
						  			<OpenInNewIcon size={14} style={{ marginTop:"-3px", marginLeft:"5px"}} color={'#BFC4D1'} onClick={(e) => {e.preventDefault();e.stopPropagation();window.open(`${isHouse ? _getBuildingURL(buildingData, 'building_slugs') : _getBuildingURL(buildingData, 'building_slugs')}/${_nameToUrl(d.address_2_normalized)}`); }} />
						  		</Fragment>}
			                    {d.foreclosure_case && (
			                    	<Tooltip title="Click for Lis Pendens details" arrow>
			                    		<span
			                    			onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleOpenLisPendens(d); }}
			                    			style={{marginLeft:6,padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(220,53,69,0.13)',color:'#a01228',border:'1px solid rgba(220,53,69,0.45)',fontWeight:500,whiteSpace:'nowrap',cursor:'pointer',display:'inline-block'}}
			                    		>Lis Pendens</span>
			                    	</Tooltip>
			                    )}
			                    <br/><span className="light-text small-text" style={{color:"#858AA1"}}>{d.neighborhood && d.neighborhood[0] ? `${_capitalizeText(d.neighborhood[0])}, ` : ''} {_capitalizeText(d.borough)}</span>

		                   	  </div>

		                   	}
		                   	
		                   	
		                   	
		                   	
		                  </TableCell>
						  <TableCell
							  className="material-table__cell material-table__cell-right"
							  size="small"   
							  style={{minWidth:250,maxWidth:400,whiteSpace:"normal"}}                       
							>
								{/* <span className="light-text small-text">{d.owner && d.owner !== 'unavailableowner' ? <Fragment>{_capitalizeText(d.owner.replace(/,(?=\S)/, ' '))}</Fragment>  : '--'}</span> */}
								{/* <p className="small-text">Enformion</p> */}
								<div style={{display:'inline-flex',alignItems:'flex-start',gap:6}}>
									<div>
										{owners.map((name, idx) => {
										  var person = _getFirstAndLastFromFullName(name);
										  var displayName = person.display ? person.display : [person.first_name, person.middle_name, person.last_name]
										  .filter(Boolean)
										  .join(' ');
										  var modalKey = d.id + '-' + idx;
										  return (
											<SkipTraceUnifiedModal
											  user={user}
											  key={'stm-' + idx}
											  first_name={'' + person.first_name}
											  last_name={'' + person.last_name}
											  address_1={'' + d.display_full_street_address}
											  address_2={'' + d.address_2_normalized}
											  city={'' + d.city}
											  county={'' + d.county}
											  state={'' + d.state}        // was d.city; using state here
											  zip={'' + d.zip}
											  triggerDisplay={_capitalizeText(displayName)}       // individual's name as trigger label
											  borough_code={d.borough_code}
											  block={d.block}
											  lot={d.lot}
											  property={d}
											  isOpen={this.state.openModalKey === modalKey}
											  onOpen={() => this.handleOpenModal(modalKey)}
											  onClose={this.handleCloseModal}
											/>
										  )
										})}
									</div>
									{d.absentee_owner && String(d.property_status || '').toLowerCase() !== 'sponsor' && (
										<span style={{flexShrink:0,marginTop:3,padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(255,200,0,0.18)',color:'#7a5c00',border:'1px solid rgba(255,200,0,0.45)',fontWeight:500,whiteSpace:'nowrap'}}>Absentee</span>
									)}
									{/* Unmasked pill removed — SkipTraceUnifiedModal trigger now shows the signatory name with the LLC in parens */}
									{/* {d.llc_unmasked && (
										<span title={d.llc_signatory_name} style={{padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(0,170,255,0.13)',color:'#0059a3',border:'1px solid rgba(0,170,255,0.35)',fontWeight:500,whiteSpace:'nowrap'}}>Unmasked</span>
									)} */}
								</div>
							</TableCell>
		                  
		                 
		                  <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small"                          
		                  >
		                  	
		                  	<span className="light-text small-text">{d.bedrooms > -1 ? d.bedrooms === 0 ? 'Studio' : d.bedrooms+' Bed' : '--'}</span>
		                  	
		                  </TableCell>
		                  <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small"                          
		                  >
		                  	
		                  	<span className="light-text small-text">{d.baths > -1 ? d.baths+' Bath' : '--'}</span>
		                  	
		                  </TableCell>
						  <TableCell
							className="material-table__cell material-table__cell-right"
							size="small"                          
						  >
							  {	d.current_status === 'in contract' ? 
								  <Fragment>
								  {parseInt(moment.unix(d.last_contract_date).format('YYYY')) > 1970 ? 
									  <Fragment>
									<span className="light-text small-text">{moment.unix(d.last_contract_date).format('MM/DD/YYYY')}</span>
									  <span className="light-text xsmall-text no-wrap"><br/>(Contract Date - {moment.unix(d.last_contract_date).fromNow()})</span>
									  </Fragment>	
								:
									<span className="light-text xsmall-text no-wrap">--</span>
								}	
								</Fragment> 
								: d.current_status === 'not_yet_recorded' ? 	   
									<span className="light-text small-text no-wrap">Not Yet Recorded</span>               		
								  : d.last_sold_date && d.last_sold_date !== 0 ?
								  <Fragment> 
								<span className="light-text small-text">{moment.unix(d.last_sold_date).format('MM/DD/YYYY')}</span>
								<span className="light-text xsmall-text no-wrap"><br/>({moment.unix(d.last_sold_date).fromNow()})</span>
								{d.current_status === 'not_yet_recorded' && <span className="light-text xsmall-text no-wrap"><br/>(Not Yet Recorded)</span>}
								</Fragment>	
								:
								  <span className="light-text small-text">--</span>
							  }
						  </TableCell> 
						  <TableCell
							  className="material-table__cell material-table__cell-right"
							  size="small" 
							  align="center"
							>
								{  (d.last_sold_price && d.last_sold_price > 100) ?
									<Fragment>
										<span className="small-text">{_shouldShow(d.last_sold_price) ? `$${_formatNumber(d.last_sold_price)}` : "--"}
									  {soldPriceChange === false ? null : soldPriceChange > 0 ? 
											<Tooltip title={`Unit was last listed for ${soldPriceChange}% above the last asking price`}>
												<IconButton size={`small`} style={{background:'transparent'}}>
												<ArrowUpIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#4ce1b6" />
											  </IconButton>
											</Tooltip> : 
										soldPriceChange == 0 ?
											<Tooltip title={`Unit was last listed for the same price as the last asking price`}>
												  <IconButton size={`small`} style={{background:'transparent'}}>
												  <ArrowEqualIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#A3ADC2" />
												</IconButton>
											  </Tooltip>
											  :
											<Tooltip title={`Unit was last listed for ${soldPriceChange}% below the last asking price`}>
												<IconButton size={`small`} style={{background:'transparent'}}>
												<ArrowDownIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#FF206E" />
											  </IconButton>
											</Tooltip>
									  }   
									  </span>
									  {soldPriceChange !== false ? 
										<span className="light-text small-text" style={{color:"#858AA1"}}>
											  <br/> {soldPriceChange > 0 ? "+": ""}{soldPriceChange ==0 ? '-0%' : `${soldPriceChange}%`} vs. OP
										  </span>
										  
										  :null
									  } 
									</Fragment>
								:
									<Fragment>
										<span className="light-text small-text">--</span>
									</Fragment>
								}
							</TableCell>
							<TableCell
							  className="material-table__cell material-table__cell-right"
							  size="small" 
							  align="center"
							>
							
							  {typeof d["div(last_sold_price, sq_ft)"] === 'number' && d["div(last_sold_price, sq_ft)"] > 100 ? 
								  <span className="small-text">
												${_formatNumber(d["div(last_sold_price, sq_ft)"])}
									</span>
									:
									<span className="small-text">
										--
									</span>
								}
							</TableCell>
							
						  
		                   <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small" 
		                    align="center"
		                  >
		                  	{ (d.offering_status === 'in contract') && _shouldShow(d.last_contract_price) && d.last_contract_price > 100  ? 
		                  		<Fragment>
		                  			<span className="small-text">
		                  			
		                  				{_shouldShow(d.last_contract_price) ? `$${_formatNumber(d.last_contract_price)}` : "--"}
		                  			</span>
		                  			
		                  		</Fragment>
		                  	: _shouldShow(d.last_listed_sale_price_all) && d.last_listed_sale_price_all > 100 ? 
		                  		<Fragment>
		                  			<span className="small-text">
		                  				{_shouldShow(d.last_listed_sale_price_all) ? `$${_formatNumber(d.last_listed_sale_price_all)}` : "--"} {opPriceChange === false ? null : opPriceChange > 0 ? 
											  <Tooltip title={`Unit was last listed for ${opPriceChange}% above the initial offering price`}>
											  	<IconButton size={`small`} style={{background:'transparent'}}>
												  <ArrowUpIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#4ce1b6" />
												</IconButton>
											  </Tooltip> : 
										  opPriceChange == 0 ?
										  	<Tooltip title={`Unit was last listed for the same price as the initial offering price`}>
													<IconButton size={`small`} style={{background:'transparent'}}>
													<ArrowEqualIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#A3ADC2" />
												  </IconButton>
												</Tooltip>
												:
											  <Tooltip title={`Unit was last listed for ${opPriceChange}% below the initial offering price`}>
											  	<IconButton size={`small`} style={{background:'transparent'}}>
											  	<ArrowDownIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#FF206E" />
												</IconButton>
											  </Tooltip>
										} 
		                  			</span>
									{opPriceChange !== false ? 
									  <span className="light-text small-text" style={{color:"#858AA1"}}>
											<br/> {opPriceChange > 0 ? "+": ""}{opPriceChange ==0 ? '-0%' : `${opPriceChange}%`} vs. OP
										</span>
										
										:null
									} 
		                  			
		                  		</Fragment>
		                  		
		                  	: 
		                  		<Fragment>
		                  			<span className="small-text">{_shouldShow(d.offering_price) ? `$${_formatNumber(d.offering_price)}` : "--"}</span>
						  			{_shouldShow(d.offering_price) && <span className="light-text xsmall-text no-wrap"></span>}
		                  		</Fragment>
		                  	}
		                  </TableCell>
						   {/* <TableCell
							  className="material-table__cell material-table__cell-right"
							  size="small" 
							  align="center"
							>
							
							  {opPriceChange !== false ? 
								  <Fragment>
								<span className="small-text">
									   {opPriceChange === false ? null : opPriceChange > 0 ? 
											<Tooltip title={`Unit was last listed for ${opPriceChange}% above the initial offering price`}>
												<IconButton size={`small`} style={{background:'transparent'}}>
												<ArrowUpIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#4ce1b6" />
											  </IconButton>
											</Tooltip> : 
										opPriceChange == 0 ?
											<Tooltip title={`Unit was last listed for the same price as the initial offering price`}>
												  <IconButton size={`small`} style={{background:'transparent'}}>
												  <ArrowEqualIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#A3ADC2" />
												</IconButton>
											  </Tooltip>
											  :
											<Tooltip title={`Unit was last listed for ${opPriceChange}% below the initial offering price`}>
												<IconButton size={`small`} style={{background:'transparent'}}>
												<ArrowDownIcon size={15} style={{marginTop:-2,maringLeft:-3}} color="#FF206E" />
											  </IconButton>
											</Tooltip>
									  } {opPriceChange > 0 ? "+": ""}{opPriceChange ==0 ? 'No Change' : `${opPriceChange}%`}
								  </span>
								  <span className="light-text small-text" style={{color:"#858AA1"}}>
									  <br/> (OP: ${_formatNumber(d.offering_price)})
								  </span> 
								  </Fragment>
								  : "--"
							  } 
							</TableCell>  */}
		                  <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small" 
		                    align="center"
		                  >
		                  
		                    {typeof d["div(last_listed_sale_price_all, sq_ft)"] === 'number' && d["div(last_listed_sale_price_all, sq_ft)"] > 100 ? 
			                    <span className="small-text">
			                  				${_formatNumber(d["div(last_listed_sale_price_all, sq_ft)"])}
			                  	</span>
			                  	:
			                  	<span className="small-text">
			                  		--
			                  	</span>
			                  	
		                  	}
		                  </TableCell>
		                   
		                  <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small" 
		                    align="center"
		                  >
		                  	{d.offering_verified_status === "active"  || d.offering_sq_ft > -1 ? 
		                  		<span className="light-text small-text">{_shouldShow(d.offering_sq_ft) ? _formatNumber(d.offering_sq_ft)+' sf' : '--'}</span>
		                  	:
		                  		<span className="light-text small-text">{_shouldShow(d.sq_ft) ? _formatNumber(d.sq_ft)+' sf' : '--'}</span>
		                  	}
		                  </TableCell>    
		                  <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small" 
		                    align="center"
		                  ><span className="light-text small-text">{_shouldShow(d.offering_exterior_sq_ft) ? <React.Fragment>{_formatNumber(d.offering_exterior_sq_ft)} sf</React.Fragment>  : `--`}</span>
		                </TableCell>
		                  
		                {/*   <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    align="center"
		                  >
		                  {
			                 d.offering_monthly_carrying_charges && d.offering_monthly_carrying_charges > 0 ?
			                  	<span className="light-text small-text">${_formatNumber(d.offering_monthly_carrying_charges)}</span>
			                : ((d.monthly_carrying_charges && d.monthly_carrying_charges > 0) && (d.monthly_taxes && d.monthly_taxes > 0)) ? 
		                  	<span className="light-text small-text">${d.monthly_carrying_charges && d.monthly_carrying_charges > 0 ? _formatNumber(d.monthly_carrying_charges) :  (d.monthly_fees + d.monthly_taxes) > 0 ? _formatNumber(d.monthly_fees + d.monthly_taxes) : ' --'} / mo</span>
		                  	: <span className="light-text small-text"> -- </span>
		                  }
		                  </TableCell> */}
		                           
		                
		                </TableRow>
		              );
		            })}
		          {emptyRows > 0 && (
		            <TableRow style={{ height: 49 * emptyRows }}>
		              <TableCell colSpan={6} />
		            </TableRow>
		          )}
		        </TableBody> 
		        
              
		      </Table>
		      </div>
		     
			   {!reactTableFiltered &&
				<div className="unit__load">
				    <Tooltip title="Load more units">
				        <Button
					        onClick={(e) => {this._loadMore(e)}}
					         variant="contained"
					         color="news"
					         className={`timeline__load-more`}
					         startIcon={<LoadMoreIcon />}
					         disabled={this.state.fetchInProgress || this.state.noMoreResults}
					     >	{`${this.state.fetchInProgress ? "Loading..." : this.state.noMoreResults ? "No More Units" : "Load More"}`}
					     </Button>
				  	</Tooltip>
			    </div>
			    }
				<LisPendensModal
					isOpen={!!this.state.lisPendensProperty}
					onClose={this.handleCloseLisPendens}
					foreclosureCase={this.state.lisPendensProperty && this.state.lisPendensProperty.foreclosure_case}
					property={this.state.lisPendensProperty}
				/>
			</Fragment>
		);
	}
}

export default connect(state => ({
  user: state.user
}))(UnitsListTable);